var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 280,
    viewBox: "0 0 281 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 281,
    height: 280
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 280,
    height: 280,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.498 253.169C86.4425 253.169 82.2619 251.516 78.9564 248.211C75.6508 244.905 73.998 240.725 73.998 235.669V175.003H82.1647V217.586H198.831V62.4193H82.1647V105.003H73.998V44.3359C73.998 39.2804 75.6508 35.0998 78.9564 31.7943C82.2619 28.4887 86.4425 26.8359 91.498 26.8359H189.498C194.554 26.8359 198.734 28.4887 202.04 31.7943C205.345 35.0998 206.998 39.2804 206.998 44.3359V235.669C206.998 240.725 205.345 244.905 202.04 248.211C198.734 251.516 194.554 253.169 189.498 253.169H91.498ZM82.1647 225.753V235.669C82.1647 238.003 83.1369 240.141 85.0814 242.086C87.0258 244.03 89.1647 245.003 91.498 245.003H189.498C191.831 245.003 193.97 244.03 195.915 242.086C197.859 240.141 198.831 238.003 198.831 235.669V225.753H82.1647ZM82.1647 54.2526H198.831V44.3359C198.831 42.0026 197.859 39.8637 195.915 37.9193C193.97 35.9748 191.831 35.0026 189.498 35.0026H91.498C89.1647 35.0026 87.0258 35.9748 85.0814 37.9193C83.1369 39.8637 82.1647 42.0026 82.1647 44.3359V54.2526Z",
    fill: "#303468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.458 170.166L117.291 176L153.458 139.833L117.291 103.667L111.458 109.5L137.708 135.75H31.5415V143.916H137.708L111.458 170.166Z",
    fill: "#476DFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSuccess);
export default __webpack_public_path__ + "static/media/phone_success.1422278781628533c84d2b5961b27d7c.svg";
export { ForwardRef as ReactComponent };